import { ElementsArray } from 'polotno/model/group-model';

export const alignPosition = ({ position, elements, storeWidth }: { position: string; elements: ElementsArray; storeWidth: number }) => {
    elements.forEach(element => {
        if (position === 'left') {
            element.set({ x: 0 });
        } else if (position === 'center') {
            element.set({ x: storeWidth / 2 - element.width / 2 });
        } else if (position === 'right') {
            element.set({ x: storeWidth - element.width });
        }
    });
};
